export default "__VITE_ASSET__3vT60zC3__"